import { fetchPost } from '../Service/ApiService'

export const bulkSendIntroWithdraw = (selectedIds, resolve, reject) => {
   

    try {
        fetchPost(`introwithdrawrequest/bulksend`, selectedIds, {
            success: (res) => { resolve(res) },
            fail: (res) => { reject(res) },
            error: (err) => {
                reject({ status: false, message: "Unable to connect server" })
            }
        })
    } catch (e) {
        reject({ status: false, message: "Unable to process operation" })
    }
};






